module.exports = __webpack_public_path__ + "heart_animation.a715a8e447ae57ef754f.png";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/img/heart_animation.png
// module id = ../../../../../src/assets/img/heart_animation.png
// module chunks = styles briefcase.module